import { Mail } from "lucide-react";
import { Button, Text } from "@components/atoms";

interface SuccessStepProps {
  onAccept: () => void;
  email?: string;
}

/**
 * Success step component for LoginModal
 * Updated for email verification flow
 */
export function SuccessStep({ onAccept, email }: SuccessStepProps) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 text-center">
      <Text variant="h2" as="h2" className="font-semibold text-black">
        Verifica tu correo
      </Text>

      {/* Icono más acorde */}
      <Mail size={140} className="text-primary-110" />

      <Text variant="body" as="p" className="text-black">
        Hemos enviado un enlace de verificación a
      </Text>

      <Text variant="body" as="p" className="font-medium text-black">
        {email ?? "tu correo electrónico"}
      </Text>

      <Text variant="body" as="p" className="text-gray-600">
        Debes verificar tu cuenta antes de iniciar sesión.
      </Text>

      <Button
        className="mt-2 w-full max-w-[340px] h-[50px] text-h5 border border-primary-110 bg-secondary-120 text-primary-110 hover:bg-secondary-120 hover:opacity-90"
        onClick={onAccept}
      >
        Entendido
      </Button>
    </div>
  );
}